export default {
    wechatPopup_00001: "",
    wechatPopup_00002: "启用开启后，车主每日首次打开小程序，自动弹窗。启用开关关闭后，可重新编辑。",
    wechatPopup_00003: "预览",
    wechatPopup_00004: "",
    wechatPopup_00005: "跳转页面",
    wechatPopup_00006: "",
    wechatPopup_00007: "",
    wechatPopup_00008: "",
    wechatPopup_00009: "",
    wechatPopup_000010: "",
    wechatPopup_000011: "",
    wechatPopup_000012: "",
    wechatPopup_000013: "",
    wechatPopup_000014: "",
    wechatPopup_000015: "选择活动类型",
    wechatPopup_000016: "请粘贴您的公众号文章链接，微信公众平台：",
    wechatPopup_000017: "",
    wechatPopup_000018: "",
    wechatPopup_000019: "请设置活动ID ",
    wechatPopup_000020: "上传",
    wechatPopup_000021: "无跳转",
   


    wechatPopup_000022: "活动页面",
    wechatPopup_000023: "公众号链接",
    wechatPopup_000024: "储值送返",
    wechatPopup_000025: "自由领取",
    wechatPopup_000026: "邀请好友",
    wechatPopup_000027: "购买卡券",
    wechatPopup_000028: "请设置跳转页面",
    wechatPopup_000029: "活动名称",
    wechatPopup_000030: "选择活动",
    wechatPopup_000031: "查看详情",
    wechatPopup_000032: "广告投放",
    wechatPopup_000033: "请输入备注信息",
    wechatPopup_000034: "备注信息",
    wechatPopup_000035: "已知晓",
    wechatPopup_000036: "弹窗内容设置",
    wechatPopup_000037: "弹窗标题",
    wechatPopup_000038: "请输入弹窗标题",
    wechatPopup_000039: "弹窗内容",
    wechatPopup_000040: "请输入弹窗内容",
    wechatPopup_000041: "跳转页面",
    wechatPopup_000042: "请输入弹窗标题",
    wechatPopup_000043: "请输入弹窗内容",
    wechatPopup_000044: "请输入备注信息",
    wechatPopup_000045: "点击上方编辑按钮开始编辑弹窗设置",
    wechatPopup_000046: "组队打榜",
    wechatPopup_000047: "启用弹窗",
}